import { getEnvVar } from './config';

const synthConfig = {
  synthAPIURL: getEnvVar('SYNTH_API_URL', 'https://api.synthdata.co', true),
  supabaseURL: getEnvVar('NEXT_PUBLIC_SUPABASE_URL', '', true),
  supabaseAnonKey: getEnvVar('NEXT_PUBLIC_SUPABASE_ANON_KEY', '', true),
  synthAPIKey: getEnvVar('SYNTH_API_KEY', '', true),
  debug: getEnvVar('NEXT_PUBLIC_DEBUG', ''),
  openAIAPIKey: getEnvVar('OPENAI_API_KEY_SYNTH', '', true),
  derebitAPIURL: getEnvVar('DEREBIT_API_URL', 'https://www.deribit.com', true),
  e2bAPIKey: getEnvVar('E2B_API_KEY', '', true),
  e2bTemplateID: getEnvVar('E2B_TEMPLATE_ID', '', true),
  nextSiteURL: getEnvVar('NEXT_PUBLIC_SITE_URL', ''),
  vercelURL: getEnvVar('NEXT_PUBLIC_VERCEL_URL', ''),
  gaMeasurementId: getEnvVar('NEXT_PUBLIC_GA_MEASUREMENT_ID', ''),
  /** UTC date string (e.g. 2026-02-25T12:00:00Z); banner shows only while current time is before this date */
  maintenanceEndDateUtc: getEnvVar('NEXT_PUBLIC_MAINTENANCE_END_DATE_UTC', ''),
  intercomAppId: getEnvVar('NEXT_PUBLIC_INTERCOM_APP_ID', ''),
};

export default synthConfig;
